<div class="card">
  <div class="card-header">
    <h3>
      {{ 'findings_by_standard' | translate }}
    </h3>
  </div>
  <div class="card-body mt-3">
    <app-ngb-table [config]="tableConfig" [data]="tableData"> </app-ngb-table>
  </div>
</div>
